<template>
  <div class="content">
    <el-row style="height: 4vh; padding-left: 0.5vw; padding-top: 0.1vh;">
      <el-col :span="24" style="margin:0;">
        <div class="grid-content1 bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>物资管理</el-breadcrumb-item>
            <el-breadcrumb-item>数据统计</el-breadcrumb-item>
          </el-breadcrumb>
          <div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="content-top">
      <div>
        <div class="top-item" style="border-bottom: 2px solid #E7E7E7;">
          <p class="p-text" style="text-align: left;">机械设备总数</p>
          <p class="p-num">
            <span style="font-size: 32px;">{{dataTotal.machine || 0}}</span> / <span>台</span>
          </p>
        </div>
        <div class="top-item">
          <p class="p-text" style="text-align: left;">电器设备总数</p>
          <p class="p-num">
            <span style="font-size: 32px;">{{dataTotal.electric || 0}}</span> / <span>台</span>
          </p>
        </div>
      </div>
      <div>
        <div class="top-item" style="border-bottom: 2px solid #E7E7E7;">
          <p class="p-text" style="display: flex;justify-content: space-between;">
            <span>机械设备入场</span>
            <span style="color: #0B62F0;">{{ new Date().getMonth() + 1 }}月数据</span>
          </p>
          <p class="p-num">
            <span style="font-size: 32px;">{{dataTotal.machineinCount || 0}}</span> / <span>台</span>
          </p>
        </div>
        <div class="top-item">
          <p class="p-text" style="display: flex;justify-content: space-between;">
            <span>电器设备入场</span>
            <span style="color: #0B62F0;">{{ new Date().getMonth() + 1 }}月数据</span>
          </p>
          <p class="p-num">
            <span style="font-size: 32px;">{{dataTotal.electricinCount || 0}}</span> / <span>台</span>
          </p>
        </div>
      </div>
      <div>
        <div class="top-item" style="border-bottom: 2px solid #E7E7E7;">
          <p class="p-text" style="display: flex;justify-content: space-between;">
            <span>机械设备出场</span>
            <span style="color: #0B62F0;">{{ new Date().getMonth() + 1 }}月数据</span>
          </p>
          <p class="p-num">
            <span style="font-size: 32px;">{{dataTotal.machineoutCount || 0}}</span> / <span>台</span>
          </p>
        </div>
        <div class="top-item">
          <p class="p-text" style="display: flex;justify-content: space-between;">
            <span>电器设备出场</span>
            <span style="color: #0B62F0;">{{ new Date().getMonth() + 1 }}月数据</span>
          </p>
          <p class="p-num">
            <span style="font-size: 32px;">{{dataTotal.electricoutCount || 0}}</span> / <span>台</span>
          </p>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="main-left">
        <baidu-map style="width: 100%;height: 100%;" :center="center" :zoom="10" @ready="handler" :scroll-wheel-zoom="true" :mapClick="false">
            <bm-marker v-for="(item, index) in distribute" :key="index" :position="{lat: item.location.lat, lng: item.location.lng}" @click="look(item)"
            :icon="{url: require('../../../assets/image/towerCrane.png'), size: {width: 55, height: 65}}">
            </bm-marker>
            <bm-info-window :position="currentInfo.location" :show="show" @close="infoWindowClose" @open="infoWindowOpen">
              <p>{{currentInfo.equip_name}}</p>
              <p>经度：{{currentInfo.location?currentInfo.location.lng : '0'}}</p>
              <p>纬度：{{currentInfo.location?currentInfo.location.lat : '0'}}</p>
            </bm-info-window>
          
        </baidu-map>
        <div class="map-pos">
          <span class="circle"></span><span>机械设备在场分布</span>
        </div>
      </div>
      <div class="main-right">
        <div class="disqualification">
          <div class="title"><span class="circle"></span><span>不合格率</span></div>
          <div style="width: 100%;height: 90%;" ref="chart1"></div>
        </div>
        <div class="disqualification">
          <div class="title"><span class="circle"></span><span>不合格率</span></div>
          <div style="width: 100%;height: 90%;" ref="chart2"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port.js'
  import util from '../../../untils/util.js'
  export default {
    data() {
      return {
        projectId: '',
        dataTotal: {},
        distribute: [],  //   分布
        currentInfo: {},
        center: {
          lng: 117.17,
          lat: 31.82
        },
        show: false,   
        data1: [],  // 机械不合格率
        data2: [],  //  电器不合格率
      }
    },
    created() {
      this.projectId = util.session.get('groupId')
    },
    mounted() {
      this.getCount()
      this.getMachineDistribute()
      this.getElectricDistribute()
      this.getNoQualified()
    },
    methods: {
      handler({BMap, map}) {
        
      },
      look(item){
        console.log(item);
        this.currentInfo = item
        console.log(this.currentInfo);
        this.show = true
      },
      infoWindowOpen(){
        this.show = true
      },
      infoWindowClose(){
        this.show = false
      },
      // 获取设备总量和进出数
      getCount(){
        myHttp.getDistributionTotal({
          projectId: this.projectId,
          month: util.myTime.getCurMonth()
        }).then(resp => {
          if(resp.data.code === 200){
            this.dataTotal = resp.data.data.DataTotal
          }
        })
      },
      // 获取机械设备分布     type  1  机械   2  电器
      getMachineDistribute(){   
        myHttp.getDistributionByEquipType({
          projectId: this.projectId,
          type: '1'
        }).then(resp => {
          if(resp.data.code === 200){
            const list = resp.data.data.dataList
            for(let i=0;i<list.length;i++){
              if(list[i].location){
                list[i].location = JSON.parse(list[i].location)
                this.distribute.push(list[i])
              }
            }
          }
        })
      },
       getElectricDistribute(){   
        myHttp.getDistributionByEquipType({
          projectId: this.projectId,
          type: '2'
        }).then(resp => {
          if(resp.data.code === 200){
            const list = resp.data.data.dataList
           for(let i=0;i<list.length;i++){
              if(list[i].location){
                list[i].location = JSON.parse(list[i].location)
                this.distribute.push(list[i])
              }
            }
            console.log(this.distribute);
          }
        })
      },
      // 获取电器和机械的不合格率
      getNoQualified(){
        myHttp.getDistributionCheckResult({
          projectId: this.projectId
        }).then(resp => {
          if(resp.data.code === 200){
            const data = resp.data.data.CheckResult
            this.data1 = [data.machine1, data.machine2, data.machine3, data.machine4]
            this.data2 = [data.electric1, data.electric2, data.electric3, data.electric4]
            this.initChart1()
            this.initChart2()
          }
        })
      },
      // 机械设备不合格率
      initChart1(){
        let chart1 = this.$echarts.init(this.$refs.chart1)
        chart1.setOption({
          title: {
            text: '机械设备',
            top: 'center',
            left: 'center'
          },
          series: [
            {
              type: 'pie',
              radius: ['55%', '80%'],
              color: ['#0263FF', '#5582CA', '#67A1FF', '#9AC1FF'],
              label: {
                formatter: `{b}\n{d}%`
              },
              data: [
                {
                  name: '第一季度',
                  value: this.data1[0]
                },
                {
                  name: '第二季度',
                  value: this.data1[1]
                },
                {
                  name: '第三季度',
                  value: this.data1[2]
                },
                {
                  name: '第四季度',
                  value: this.data1[3]
                }
              ]
            }
          ]
        })
        window.addEventListener("resize", () => {
          chart1.resize();
        });
      },
      // 电器设备不合格率
      initChart2(){
        let chart2 = this.$echarts.init(this.$refs.chart2)
        chart2.setOption({
          title: {
            text: '电器设备',
            top: 'center',
            left: 'center'
          },
          series: [
            {
              type: 'pie',
              radius: ['55%', '80%'],
              color: ['#0263FF', '#5582CA', '#67A1FF', '#9AC1FF'],
              label: {
                formatter: `{b}\n{d}%`
              },
              data: [
                {
                  name: '第一季度',
                  value: this.data2[0]
                },
                {
                  name: '第二季度',
                  value: this.data2[1]
                },
                {
                  name: '第三季度',
                  value: this.data2[2]
                },
                {
                  name: '第四季度',
                  value: this.data2[3]
                }
              ]
            }
          ]
        })
        window.addEventListener('resize', () => {
          chart2.resize()
        })
      }
    },
  }
</script>

<style  scoped>
.content-top{
  display: flex;
  justify-content: space-evenly;
}
.content-top > div {
  width: 32%;
  height: 18vh;
  background: #FFFFFF;
  box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.5);
  border-radius: 6px;
}
.top-item{
  padding: 1vh 1vw;
  height: 50%;
}
.p-text{
  font-size: 1.2vw;
  color: #666;
}
.p-num{
  font-size: 1.5vw;
  color: #333;
}
.content-main{
  display: flex;
  justify-content: space-evenly;
  margin-top: 1vh;
  height: 66vh;
}
.main-left{
  position: relative;
  width: 70%;
  height: 100%;
  background: #FFFFFF;
  border: 10px solid #FFFFFF;
  box-shadow: 0px 3px 7px 0px rgba(105, 159, 204, 0.5);
  border-radius: 6px;
}
.main-right{
  width: 27%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.circle{
  display: inline-block;
  width: 0.8vw;
  height: 0.8vw;
  border-radius: 10px;
  margin-right: 10px;
  background-color: #0F62E7;
}
.map-pos{
  position: absolute;
  top: 1vh;
  left: 1vw;
  display: flex;
  align-items: center;
}
.disqualification{
  height: 48%;
  width: 100%;
  background: #FFFFFF;
  box-shadow: 2px 2px 7px 0px rgba(105, 159, 204, 0.5);
  border-radius: 6px;
  padding: 1vh 1vw;
}
.title{
  text-align: left;
}
</style>